<script lang="ts">
	import { formatify } from "@core/utils/formatify.js";

	const { text }: { text: string | undefined } = $props();

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html formatify(text)}
